/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Err_Tournament_Invalid_Table_SizeInputs */



/**
* | output |
* | --- |
* | "Invalid table size: {size}" |
*
* @param {Err_Tournament_Invalid_Table_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_invalid_table_size = /** @type {((inputs: Err_Tournament_Invalid_Table_SizeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Invalid_Table_SizeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Taille de table invalide : ${i?.size}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Tamaño de mesa no válido: ${i?.size}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Tamanho de mesa inválido: ${i?.size}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Dimensione tavolo non valida: ${i?.size}`)
	return /** @type {LocalizedString} */ (`Invalid table size: ${i?.size}`)
});